import defaultAxios, { AxiosError as AxiosErrorClass } from 'axios';
import { getLocale } from 'i18n';
import { SAS_CORRELATION_ID, SAS_USER_SESSION_ID, getLanguageCode } from 'shared';

import { getSasCorrelationId, getSasUserSessionId } from './trackingIdHelper';

const instance = defaultAxios.create({
  headers: {
    'content-type': 'application/json',
    channel: 'WEB',
    'Accept-Language': getLocale(),
    language: getLanguageCode(getLocale()),
    locale: getLocale(),
    [SAS_USER_SESSION_ID]: getSasUserSessionId(),
  },
  withCredentials: true,
});

instance.interceptors.request.use(config => {
  config.headers.set(SAS_CORRELATION_ID, getSasCorrelationId());
  return config;
});

export const axios = defaultAxios;
export const bookingAxios = instance;
export const AxiosError = AxiosErrorClass;
export const HttpStatusCode = axios.HttpStatusCode;
